import getPieOptions from "./pie";
import { Message } from 'element-ui'

class BarLine {
  constructor(x_data, serData, color, dom) {
    this.x_data = x_data;
    this.serData = serData;
    this.color = color;
    this.domObj = dom;
    console.log("TCL: BarLine -> constructor -> this.domObj", this.domObj)
  }

  setoptions() {
    let that = this;
    const legendData = this.serData.map(item => item.name)
    const unitData = this.serData.map(item => item.unit)
    return {
      tooltip: {
        trigger: 'axis',
        formatter: params => {
          let date;
          let obj = params.map((item, index) => {
            date = item.name;
            // 小圆点显示
            let dotColor = `<span style="display:inline-block;
            margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${item.color}"></span>`
            let html = '</br>'
            // return dotColor + item.seriesName + " : " + item.value + " / Unit: " + unitData[index] + html
            return dotColor + item.seriesName + " : " + item.value
          });
          obj.unshift(date + '</br>')
          return obj.join('') // 去除','
        }
      },

      legend: {
        //修复bug标记 02
        type: 'scroll',
        bottom: "0",
        //
        data: legendData
      },

      grid: {
        x: 20,
        y: 50,
        x2: 20,
        y2: 50,
        containLabel: true
      },

      toolbox: {
        show: true,
        feature: {
          // dataZoom: {
          //   yAxisIndex: 'none'
          // },
          // dataView: {  },
          magicType: { type: ['line', 'bar'], title: { line: "line", bar: "bar" } },
          myTool3: {
            title: 'pie',
            icon: 'image://data:image/x-icon;base64,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',
            onclick: function (obj, a, b, c) {
              console.log("TCL: BarLine -> setoptions -> that.serData.length", that.serData)
              // if (that.serData.length > 1) {
              //   Message.error({
              //     message: `Multiple indicators cannot be represented by pie charts!`,
              //     duration: 3000
              //   });
              //   return
              // }

              const pieData = converData(that.x_data, that.serData);
              const pieOptions = getPieOptions(pieData)
              that.domObj.clear();
              that.domObj.mergeOptions(pieOptions);
            }
          },
          // restore: {},
          saveAsImage: {
            title:'save image'
          }
        }
      },

      xAxis: {
        type: 'category',
        boundaryGap: true,
        data: this.x_data
      },

      yAxis: [
        {
          type: 'value'
        }
      ],

      series: this.serData
    }
  }
}

var converData = (linexData, lineSerData) => {
  //两条 饼状图无意义比较
  if (!lineSerData.length || lineSerData.length > 1) return;

  let pieData = []
  for (let i = 0; i < lineSerData[0].data.length; i++) {
    pieData.push({
      value: lineSerData[0].data[i],
      name: linexData[i]
    })
  }
  return pieData
}

export default (x_data, serData, color = [], dom) => {
  console.log("TCL: dom", dom)
  return new BarLine(x_data, serData, color, dom).setoptions();
}